import { SVGProps } from 'react'

const ConfirmProposalActionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 12L14 22M24 12L34 22M24 12V36"
      stroke="currentColor"
      strokeWidth="1.7647"
    />
  </svg>
)

export default ConfirmProposalActionIcon
